import { useEffect, useState } from "react";

interface UseDebounceProps<T> {
  value: T;
  delay: number;
}

export function useDebounce<T>(props: UseDebounceProps<T>): T {
  const { value, delay } = props;
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
